import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import axios from 'axios'
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import { NumericFormat } from 'react-number-format';
import Loading from "../../components/loading";
import ExchangeOperationService from "../../services/exchangeOperationService";
import ListService from "../../services/listService";
import ModalBalanceOperations from "./modals/modal-balance-operations";
import ModalDetailOperations from "./modals/modal-detail-operations";


function Home() {
    const initDashboardModel = {
        dolarMEP: parseFloat(0),
        dollar_mep_operations:[],
        dolarCable: parseFloat(0),
        dollar_cable_operations:[],
        // spread: parseFloat(0).toFixed(4),
        spread: parseFloat(0),
        spread_operations:[],
        spreadCable: parseFloat(0),
        spread_cable_operations:[],
        spreadMep: parseFloat(0),
        adjustment: parseFloat(0),
        spread_mep_operations:[],
        id:'',
        name:'',
    }
    const navigate = useNavigate();
    let initManagersArray = []
    const [cargando, setCargando] = useState(true)
    const [listManagers, setListManagers] = useState([]);
    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));
    let defaultDate = new Date().toISOString().slice(0,10);
    const [searchDate, setSearchDate] = useState(defaultDate);
    const [searchDateTo, setSearchDateTo] = useState(defaultDate);
    const [processed, setPorcessed] = useState(false);
    const [modalBalanceOpen, setModalBalanceOpen] = useState(false);
    const [selectedBalance, setSelectedbalance] = useState([]);
    const [selectedBalanceTitle, setSelectedbalanceTitle] = useState('');
    const [listMe, setListMe] = useState([]);    
    const [listDetail, setListDetail] = useState('');    
    const [modalDetailOpen, setModalDetailOpen] = useState(false);
    const [modalDetailType, setModalDetailType] = useState('');
    const [modalDetailAdjustment, setModalDetailAdjustment] = useState(0);
    let sumDolarMEP = parseFloat(0);
    let sumDolarCable = parseFloat(0);
    let sumSpreadMep = parseFloat(0);
    let sumSpreadCable = parseFloat(0);
    let sumSpreadARS = parseFloat(0);   

    useEffect(() => {
        if(cargando){ 
            doLoad().then()
        }
    }, [false]);

    useEffect(() => {
        if(listManagers.length > 0 && !processed){
            doCalculator().then()
        }else{
            if(processed){
                let me = listManagers.find(({ id }) => id === userProfile.id);
                if(me !== undefined){ setListMe(me) }
            }
        }
    // }, [searchDate, listManagers]);
    }, [listManagers]);

    const doSearch = async (date) => {
        let newdate = new Date(date).toISOString().slice(0,10)
        setPorcessed(false)
        setSearchDate(newdate);
    }

    const doSearchTo = async (date) => {
        let newdate = new Date(date).toISOString().slice(0,10)
        setPorcessed(false)
        setSearchDateTo(newdate);
    }

    const createArray = async (portfolioArray) => {
        let array = [];
        portfolioArray.forEach((item) => {
            if(item.id !== 2){
                array.push({
                    ...initDashboardModel,
                    id: item.id,
                    name: item.name,
                })
            }
        }); 
        initManagersArray = array;
    }

    const doLoad =  async () => {
        try {
            setCargando(true) 
            // // Portfolio Managers
            const responsePortfolio = await ListService.getPortfolioManagersList()
            await createArray(responsePortfolio.data)
            sessionStorage.setItem('initManagersArray', JSON.stringify(initManagersArray) );
            setListManagers(initManagersArray)
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
        } finally{ setCargando(false) }
    }

    const doCalculator = async () => {
        try {
            setCargando(true) 
            // HOME INFORMATION
            const responseBalance = await ExchangeOperationService.getHomeInformation(searchDate, searchDateTo)
            const auxarr = JSON.parse(sessionStorage.getItem("initManagersArray"));
            let newarr = [...auxarr];
            if(responseBalance.data.length > 0){
                /* if(true){
                    responseBalance.data.forEach((item) => {
                        if(item.portfolio_manager_id === 7){
                            let manager = newarr.find(({ id }) => id === item.portfolio_manager_id);   
                            manager = { 
                                ...manager, 
                                spread : item.spread_pesos,
                                spread_operations: item.spread_pesos_operations,
                                spreadCable: item.spread_cable,
                                spread_cable_operations: item.spread_cable_operations,
                                spreadMep: item.spread_mep,
                                spread_mep_operations: item.spread_mep_operations,
                                dolarMEP: item.dollar_mep,
                                dollar_mep_operations: item.dollar_mep_operations,
                                dolarCable: item.dollar_cable,
                                dollar_cable_operations: item.dollar_cable_operations, 
                                adjustment: item.adjustment,
                            }
                            let findIndex = newarr.findIndex(({ id }) => id === item.portfolio_manager_id);
                            newarr[findIndex] = manager;
                        }
                    });
                }else{ */
                    responseBalance.data.forEach((item) => {
                        let manager = newarr.find(({ id }) => id === item.portfolio_manager_id);   
                        manager = { 
                            ...manager, 
                            spread : item.spread_pesos,
                            spread_operations: item.spread_pesos_operations,
                            spreadCable: item.spread_cable,
                            spread_cable_operations: item.spread_cable_operations,
                            spreadMep: item.spread_mep,
                            spread_mep_operations: item.spread_mep_operations,
                            dolarMEP: item.dollar_mep,
                            dollar_mep_operations: item.dollar_mep_operations,
                            dolarCable: item.dollar_cable,
                            dollar_cable_operations: item.dollar_cable_operations, 
                            adjustment: item.adjustment,
                        }
                        let findIndex = newarr.findIndex(({ id }) => id === item.portfolio_manager_id);
                        newarr[findIndex] = manager;
                    });
                // }
            }
            setPorcessed(true)
            setListManagers(newarr)
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
        } finally{ setCargando(false) }
    }

    // MODAL GANANCIA
    const trgSpreadModal = async (obj, type) => {
        setSelectedbalanceTitle('Ganancia '+ obj.name)
        if(type === 'ARS'){
            if(obj.spread_operations.length > 0){
                let output = '';
                obj.spread_operations.forEach((item) => {  output += item + ',' })
                setListDetail(output)
                setModalDetailType('Ganancia')
                setModalDetailOpen(true)
                setModalDetailAdjustment(obj.adjustment)
            }
        }else if(type === 'Cable'){
            if(obj.spread_cable_operations.length > 0){
                let output = '';
                obj.spread_cable_operations.forEach((item) => { output += item + ',' })
                setListDetail(output)
                setModalDetailOpen(true)
                setModalDetailType('USD')
            }
        }else if(type === 'MEP'){
            if(obj.spread_mep_operations.length > 0){
                let output = '';
                obj.spread_mep_operations.forEach((item) => {  output += item + ',' })
                setListDetail(output)
                setModalDetailOpen(true)
                setModalDetailType('USD')
            }
        }
    }

    // MODAL BALANCE
    const trgBalanceModal = async (obj, type) => {
        if(type === 'Cable'){
            if(obj.dollar_cable_operations.length > 0){
                setSelectedbalanceTitle('Balance '+ obj.name)
                setListDetail(obj.dollar_cable_operations)
                setSelectedbalance(obj)
                setModalBalanceOpen(true)
            }
        }else if(type === 'MEP'){
            if(obj.dollar_mep_operations.length > 0){
                setSelectedbalanceTitle('Balance '+ obj.name)
                setListDetail(obj.dollar_mep_operations)
                setSelectedbalance(obj)
                setModalBalanceOpen(true)
            }
        }
    }

    const doExport = async () => {
        // window.open(process.env.REACT_APP_API_URL+"exchange-operations/download/excel/intermediation?token="+userProfile.token+"&date="+searchDate, '_blank')
        window.open(process.env.REACT_APP_API_URL+"exchange-operations/download/excel/intermediation?token="+userProfile.token+"&from="+searchDate+"&to="+searchDateTo, '_blank')
    }

    if(cargando){ return( <Loading></Loading> ) }

    return (

        <div className="container-fluid flex-grow-1 container-p-y">
            
            <div className="card bg-transparent shadow-none my-6 border-0">
                <div className="card-body row p-0 pb-6 g-6">
                    <div className="col-12 col-lg-6">
                        <h5 className="mb-2">Bienvenido,<span className="h4"> {userProfile.fullName} 👋🏻</span></h5>
                        <div className="col-12 col-lg-12"><p>Tu capital como punto de partida. </p></div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Card variant="solid" color="natural" className="card">
                            <CardContent>
                                <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                                    <Grid xs={12} md={5} lg={5}>
                                        <FormControl>
                                            <FormLabel className="form-labels">Desde</FormLabel>
                                            <Input type="date" size="sm" placeholder=""
                                                value={searchDate}
                                                onChange={(e) => doSearch(e.target.value)}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid xs={12} md={5} lg={5}>
                                        <FormControl>
                                            <FormLabel className="form-labels">Hasta</FormLabel>
                                            <Input type="date" size="sm" placeholder=""
                                                value={searchDateTo}
                                                onChange={(e) => doSearchTo(e.target.value)}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid xs={12} md={2} lg={2}>
                                        <button type="button" className="btn btn-sm btn-outline-info mt-4" title="Buscar" onClick={doCalculator} >
                                            <i className="tf-icons bx bx bx-search" />
                                        </button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
            
            <Grid container spacing={2} sx={{ flexGrow: 1 }} className="mt-0">
                <Grid xs={12} md={12} lg={12}>
                    <Card variant="solid" color="natural" className="card">
                        <CardContent>
                            <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                                <Grid xs={12} md={9} lg={6}>
                                    <Typography level="title-md" textColor="inherit">Operaciones de Intermediación</Typography>
                                    <Typography level="body-sm" textColor="neutral.300">Listado de operaciones de todos los comerciales.</Typography>
                                </Grid>
                                <Grid xs={12} md={3} lg={6}>
                                    <div className="btn-group float-end" role="group">
                                        <button type="button" className="btn btn-sm btn-outline-secondary" title="Exportar" onClick={doExport} >
                                            <i className="tf-icons bx bx bx-cloud-download" />
                                        </button>
                                    </div>
                                </Grid> 
                                {/* <Grid xs={12} md={2} lg={2}>
                                    <FormControl>
                                        <FormLabel className="form-labels">Desde</FormLabel>
                                        <Input type="date" size="sm" placeholder=""
                                            value={searchDate}
                                            onChange={(e) => doSearch(e.target.value)}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid xs={12} md={2} lg={2}>
                                    <FormControl>
                                        <FormLabel className="form-labels">Hasta</FormLabel>
                                        <Input type="date" size="sm" placeholder=""
                                            value={searchDateTo}
                                            onChange={(e) => doSearchTo(e.target.value)}
                                        />
                                    </FormControl>
                                </Grid> */}
                            </Grid>
                        </CardContent>
                        <CardContent>
                            <table className="table table-sm table-hover dataTable dtr-column" >
                                <thead style={{backgroundColor: '#FFFFFF'}}>
                                    <tr className="text-nowrap">
                                        <th></th>
                                        <th className="text-center" colSpan={2} style={{backgroundColor: "#F2F2F2"}} >Balance</th>  
                                        <th className="text-center" colSpan={3} style={{backgroundColor: "#D2D2D2"}} >Ganancia</th>  
                                    </tr>
                                    <tr className="text-nowrap">
                                        <th>Comercial</th>
                                        <th className="text-end">Dolares MEP</th>    
                                        <th className="text-end">Dolares Cable</th>
                                        <th className="text-end">MEP</th>    
                                        <th className="text-end">Cable</th>
                                        <th className="text-end"> AR$</th>
                                    </tr>
                                </thead>
                                <tbody className="table-border-bottom-0">
                                {listManagers.map(portfolio => {
                                    if(portfolio.id !== 1){
                                        // CALCULATE TOTALES
                                        sumSpreadARS = parseFloat(sumSpreadARS) + (parseFloat(portfolio.spread) + parseFloat(portfolio.adjustment));
                                        sumDolarCable = parseFloat(sumDolarCable) + parseFloat(portfolio.dolarCable);
                                        sumDolarMEP = parseFloat(sumDolarMEP) + parseFloat(portfolio.dolarMEP);
                                        sumSpreadCable = parseFloat(sumSpreadCable) + (parseFloat(portfolio.spreadCable)  );
                                        sumSpreadMep = parseFloat(sumSpreadMep) + (parseFloat(portfolio.spreadMep));
                                        return (
                                            <tr key={portfolio.id}>
                                                <td className="pt-2 pb-2">
                                                    <div className="d-flex justify-content-start align-items-center user-name">
                                                        <div className="d-flex flex-column">
                                                            <a className="text-body text-truncate">
                                                                <span className="fw-medium">{portfolio.name}</span>
                                                            </a>
                                                        </div>
                                                    </div>    
                                                </td>   
                                                {/* BALANCE */}
                                                <td className="text-end">
                                                    <span className={portfolio.dolarMEP >= 0 ? 'text-success' : 'text-danger'} >
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={portfolio.dolarMEP} 
                                                            decimalScale={2} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator="," 
                                                            prefix={'$ '}  
                                                            onClick={() => trgBalanceModal(portfolio, "MEP")}
                                                        /> 
                                                    </span>
                                                </td>
                                                <td className="text-end">
                                                    <span className={portfolio.dolarCable >= 0 ? 'text-success' : 'text-danger'} >
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={portfolio.dolarCable} 
                                                            decimalScale={2} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator="," 
                                                            prefix={'$ '}  
                                                            onClick={() => trgBalanceModal(portfolio, "Cable")}
                                                        /> 
                                                    </span>
                                                </td>
                                                {/* GANANCIA */}
                                                <td className="text-end">
                                                    <span className={portfolio.spreadMep >= 0 ? 'text-success' : 'text-danger'} >
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={parseFloat(portfolio.spreadMep).toFixed(2)} 
                                                            decimalScale={2} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator="," 
                                                            prefix={'$ '}  
                                                            onClick={() => trgSpreadModal(portfolio, "MEP")}
                                                        /> 
                                                    </span>
                                                </td>
                                                <td className="text-end">
                                                    <span className={portfolio.spreadCable >= 0 ? 'text-success' : 'text-danger'} >
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={parseFloat(portfolio.spreadCable).toFixed(2)} 
                                                            decimalScale={2} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator="," 
                                                            prefix={'$ '}  
                                                            onClick={() => trgSpreadModal(portfolio, "Cable")}
                                                        /> 
                                                    </span>
                                                </td>
                                                <td className="text-end">
                                                    <span className={portfolio.spread + portfolio.adjustment >= 0 ? 'text-success' : 'text-danger'} >
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={(parseFloat(portfolio.spread) + parseFloat(portfolio.adjustment)).toFixed(2)} 
                                                            decimalScale={2} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator="," 
                                                            prefix={'$ '}  
                                                            onClick={() => trgSpreadModal(portfolio, "ARS")}
                                                        /> 
                                                    </span>
                                                </td>
                                            </tr>
                                        )}    
                                    }
                                )}
                                
                                </tbody>
                                <tfoot className="table-border-bottom-0">
                                    <tr style={{backgroundColor: "#F2F2F2", fontWeight: "bold"}}>
                                        <td className="text-end">TOTALES:</td>
                                        <td className="text-end">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={sumDolarMEP.toFixed(2)} 
                                                    decimalScale={2} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator="," 
                                                    prefix={'$ '}  
                                                /> 
                                        </td>
                                        <td className="text-end">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={sumDolarCable.toFixed(2)} 
                                                    decimalScale={2} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator="," 
                                                    prefix={'$ '}  
                                                /> 
                                        </td>
                                        <td className="text-end">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={sumSpreadMep.toFixed(2)} 
                                                    decimalScale={2} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator="," 
                                                    prefix={'$ '}  
                                                /> 
                                        </td>
                                        <td className="text-end">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={sumSpreadCable.toFixed(2)} 
                                                    decimalScale={2} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator="," 
                                                    prefix={'$ '}  
                                                /> 
                                        </td>
                                        <td className="text-end">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={sumSpreadARS.toFixed(2)} 
                                                    decimalScale={2} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator="," 
                                                    prefix={'$ '}  
                                                /> 
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </CardContent>
                    </Card>
                </Grid>
                

            </Grid>
            
            { selectedBalance !== '' ?
                <>               
                    <ModalDetailOperations
                        handleOpen={setModalDetailOpen} 
                        isOpen={modalDetailOpen} 
                        title={selectedBalanceTitle}
                        type={modalDetailType}
                        arrayOperations={listDetail}
                        adjustment={modalDetailAdjustment}
                    />

                    <ModalBalanceOperations 
                        handleOpen={setModalBalanceOpen} 
                        isOpen={modalBalanceOpen} 
                        title={selectedBalanceTitle}
                        portfolioManager={selectedBalance}
                        arrayOperations={listDetail}
                    />

                </>    
            :
                null
            }
            
        </div>        

        
    );

}


export default Home;